module.exports = "/_next/static/images/santai-logo-49ae5087d47a6ce1fc9e4995bcb26dc4.png";